import { Skeleton } from '@/components/ui/skeleton';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow
} from '@/components/ui/table';

const CELL_WIDTHS = ['w-4/5', 'w-3/5', 'w-2/3', 'w-1/2', 'w-3/4', 'w-2/5'];

interface TableSkeletonProps {
  columns: number;
  rows?: number;
}

export function TableSkeleton({ columns, rows = 5 }: TableSkeletonProps) {
  const columnIndexes = Array.from({ length: columns }, (_, index) => index);
  const rowIndexes = Array.from({ length: rows }, (_, index) => index);

  return (
    <div role="status" aria-busy="true">
      <span className="sr-only">Loading</span>
      <Table variant="fluid" containerClassName="pointer-events-none">
        <TableHeader>
          <TableRow>
            {columnIndexes.map((column) => (
              <TableHead key={column}>
                <Skeleton className="h-4 w-1/2" />
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {rowIndexes.map((row) => (
            <TableRow key={row}>
              {columnIndexes.map((column) => (
                <TableCell key={column}>
                  <Skeleton
                    className={`h-4 ${CELL_WIDTHS[(column + row) % CELL_WIDTHS.length]}`}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
